export const generateSlug = () => (Math.random() + 1).toString(36).substring(7)
